export default __webpack_public_path__ + "static/R2-a2b131398accb51dbe6145ee7091d300.png";